export const CONTACT = {
  phone: "971-298-7117",
  phoneHref: "tel:+19712987117",
  // Flagged for review: number taken from riverstonepartners.info on build day; the old
  // site has shown inconsistent numbers. Confirm before launch.
  domain: "riverstonepartners.info",
};

export const HERO_VIDEO = {
  src: "/videos/alpine-desktop.mp4",
  mobileSrc: "/videos/alpine-mobile.mp4",
  poster: "/images/hero-poster.jpg",
  credit: "Video: Alpine river animation, client-supplied",
};

export const IMAGES = {
  riverStones:
    "https://static.prod-images.emergentagent.com/jobs/48c09f10-a4bf-4b94-83ff-9f7f73c21c7c/images/3acd026011a688a8ed379e8d016485cc4b556c02e509af78932b03d6ceb03edb.jpeg",
  riverAerial:
    "https://images.unsplash.com/photo-1591081658714-f576fb7ea3ed?q=80&w=1800&auto=format&fit=crop",
  riverForest:
    "https://images.unsplash.com/photo-1718661934073-ecfd78710651?q=80&w=1600&auto=format&fit=crop",
  forestMountain:
    "https://images.unsplash.com/photo-1721786347536-b697c00a362f?q=80&w=1600&auto=format&fit=crop",
  wellnessPeople:
    "https://images.unsplash.com/photo-1758691737138-7b9b1884b1db?q=80&w=1600&auto=format&fit=crop",
  crypto:
    "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?q=80&w=1600&auto=format&fit=crop",
  meeting:
    "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a?q=80&w=1600&auto=format&fit=crop",
  laptopDesk:
    "https://images.unsplash.com/photo-1637502875124-eb4a9843a2fa?q=80&w=1600&auto=format&fit=crop",
  doctorOffice:
    "https://images.unsplash.com/photo-1758691462848-31a39258dbd8?q=80&w=1600&auto=format&fit=crop",
  containersAerial:
    "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?q=80&w=1600&auto=format&fit=crop",
  cargoShip:
    "https://images.unsplash.com/photo-1613690399151-65ea69478674?q=80&w=1600&auto=format&fit=crop",
  mountainClouds:
    "https://images.unsplash.com/photo-1583621913946-91a67678ec1b?q=80&w=1600&auto=format&fit=crop",
  groupLaptop:
    "https://images.unsplash.com/photo-1688380692117-63178554d76d?q=80&w=1600&auto=format&fit=crop",
  meetingHands:
    "https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop",
};

// Outbound affiliate URL — configurable. Set REACT_APP_OUTBOUND_AFFILIATE_URL in the
// frontend environment to Riverstone's approved Aspire Partners affiliate link.
// Until then, "Explore the Partner Opportunity" points at the partner inquiry form.
export const AFFILIATE_URL =
  (typeof process !== "undefined" && process.env.REACT_APP_OUTBOUND_AFFILIATE_URL) || "";

export const SERVICES = [
  {
    slug: "marketing-website-design",
    name: "Marketing & Website Design",
    short:
      "Build a stronger online presence and connect with more of the right customers.",
    benefit: "More of the right customers finding you.",
    provider: "Delivered with Veluro",
    image: IMAGES.laptopDesk,
    imageAlt: "Laptop on a wooden desk used for planning a modern website",
  },
  {
    slug: "veluro-ai-marketing",
    name: "Veluro — AI Marketing Platform",
    short:
      "An AI-powered growth team that finds high-intent buyers, launches campaigns across every channel, and books meetings.",
    benefit: "Campaigns that keep working — and meetings on your calendar.",
    provider: "Veluro · veluro.ai",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1600&auto=format&fit=crop",
    imageAlt: "Performance analytics graphs on a laptop screen",
  },
  {
    slug: "employee-health-wellness",
    name: "Employee Health & Wellness",
    short:
      "Explore programs that support employee wellbeing and complement your benefits strategy.",
    benefit: "A workforce that feels supported — and stays.",
    provider: "Delivered with EHP",
    image: IMAGES.wellnessPeople,
    imageAlt: "A team celebrating together in a bright office",
  },
  {
    slug: "medical-claims-billing",
    name: "Medical Claims & Billing",
    short:
      "Address billing complexity, outstanding receivables, and revenue-cycle inefficiencies.",
    benefit: "Revenue you’ve earned, actually collected.",
    provider: "Delivered with TFSC / 24-7 Consultancy",
    image: IMAGES.doctorOffice,
    imageAlt: "Healthcare administrator working on billing at a desk",
  },
  {
    slug: "shipping-freight",
    name: "Shipping & Freight",
    short:
      "Simplify shipping operations and uncover opportunities to improve transportation spending.",
    benefit: "Every shipping dollar, finally visible.",
    provider: "Delivered with Shipstore & ShipSigma",
    image: IMAGES.containersAerial,
    imageAlt: "Aerial view of a shipping container yard",
  },
  {
    slug: "emerging-opportunities",
    name: "Emerging Opportunities",
    short:
      "Explore introductions to Sixth Shock and Prosperlink and learn whether their offerings fit your goals.",
    benefit: "A clear-eyed look at what’s next.",
    provider: "Introductions to Sixth Shock & Prosperlink",
    image: IMAGES.crypto,
    imageAlt: "A cryptocurrency coin representing emerging digital opportunities",
  },
];

export const SOLUTION_OPTIONS = [
  {
    key: "attract-more-customers",
    label: "Attract more customers",
    service: "marketing-website-design",
    recommendation:
      "Marketing & Website Design is usually the right starting point. Together with Veluro, we help you sharpen your online presence so the right customers can find you — and act.",
    cta: "Explore Marketing & Website Design",
    interest: "marketing-website-design",
  },
  {
    key: "ai-marketing",
    label: "Put AI marketing to work",
    service: "veluro-ai-marketing",
    recommendation:
      "Veluro is an AI-powered growth team: it finds high-intent buyers, launches campaigns across every channel, books meetings, and watches the health of your business around the clock.",
    cta: "Explore Veluro — AI Marketing Platform",
    interest: "veluro-ai-marketing",
  },
  {
    key: "improve-our-website",
    label: "Improve our website",
    service: "marketing-website-design",
    recommendation:
      "A modern, responsive website does quiet work for your business every day. Through our Marketing & Website Design offering with Veluro, we'll review where your site stands and what a stronger version could do.",
    cta: "Explore Marketing & Website Design",
    interest: "marketing-website-design",
  },
  {
    key: "support-our-employees",
    label: "Support our employees",
    service: "employee-health-wellness",
    recommendation:
      "Employee Health & Wellness explores wellbeing programs — preventive-care support, virtual visits, and mental health resources — designed to complement the benefits you already offer.",
    cta: "Explore Employee Health & Wellness",
    interest: "employee-health-wellness",
  },
  {
    key: "improve-revenue-operations",
    label: "Improve healthcare revenue operations",
    service: "medical-claims-billing",
    recommendation:
      "Medical Claims & Billing addresses billing complexity, denials, and outstanding receivables. Our specialists at TFSC / 24-7 Consultancy strengthen the revenue behind the care you provide.",
    cta: "Explore Medical Claims & Billing",
    interest: "medical-claims-billing",
  },
  {
    key: "optimize-shipping",
    label: "Optimize shipping",
    service: "shipping-freight",
    recommendation:
      "Shipping & Freight pairs Shipstore's shipping automation platform with ShipSigma's spend analysis and invoice auditing — a clearer picture of where every shipping dollar goes.",
    cta: "Explore Shipping & Freight",
    interest: "shipping-freight",
  },
  {
    key: "explore-emerging-opportunities",
    label: "Explore emerging opportunities",
    service: "emerging-opportunities",
    recommendation:
      "Emerging Opportunities is where we introduce select clients to Sixth Shock and Prosperlink — carefully, and only when their offerings may fit your goals. A conversation comes first.",
    cta: "Explore Emerging Opportunities",
    interest: "emerging-opportunities",
  },
  {
    key: "become-a-partner",
    label: "Learn about becoming a partner",
    service: "become-a-partner",
    recommendation:
      "The Aspire Partners opportunity lets you put your professional relationships to work — introducing businesses to relevant solutions without selling or managing delivery.",
    cta: "Explore the Partner Opportunity",
    interest: "become-a-partner",
  },
];

export const NAV_LINKS = [
  { label: "Solutions", to: "/solutions", children: SERVICES },
  { label: "Our Approach", to: "/approach" },
  { label: "About", to: "/about" },
  { label: "Become a Partner", to: "/become-a-partner" },
  { label: "Contact", to: "/contact" },
];

export const MARQUEE_WORDS = [
  "Growth",
  "Efficiency",
  "Employee Wellbeing",
  "Opportunity",
  "Enduring Partnerships",
];
